import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CantCreatePaymentLinkPopUpProps } from "../../payment.types";

import { PaymentPopUpCloseIcon } from "../../../../assets/icons/MUI/PaymentIcons";
import WarningImage from "../../../../assets/images/payments/cant-create-payment-link.png";

const CantCreatePaymentLinkPopUp = ({
  onClose,
  open,
  openLearnMorePopUp,
  handleSetupPaymentAccount,
}: CantCreatePaymentLinkPopUpProps) => {
  const { t } = useTranslation();

  const handleOpenLearnMorePopUp = () => {
    onClose();
    openLearnMorePopUp();
  };

  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "640px",
          borderRadius: "12px",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          padding: "24px 0",
          borderBottom: "1px solid #E4E7EC",
        }}
      >
        <Typography
          component="h3"
          sx={{
            color: "#101828",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
            width: "100%",
          }}
        >
          {t("pages.payment.overview.cantCreatePaymentLinkPopUP.createPaymentLink")}
        </Typography>
        <IconButton
          onClick={() => onClose()}
          sx={{
            position: "absolute",
            right: "16px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <PaymentPopUpCloseIcon />
        </IconButton>
      </Box>
      <Box
        component="figure"
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
          alignItems: "center",
        }}
      >
        <img src={WarningImage} width="96px" height="96px" />
        <Box component="figcaption" sx={{ display: "flex", flexDirection: "column", rowGap: "16px" }}>
          <Typography
            component="span"
            sx={{
              color: "#111",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "32px",
            }}
          >
            {t("pages.payment.overview.cantCreatePaymentLinkPopUP.cantCreatePaymentLink")}
          </Typography>
          <Typography
            component="p"
            sx={{
              color: "#5E6278",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {t("pages.payment.overview.cantCreatePaymentLinkPopUP.setupYourPaymentAccountFirst")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          columnGap: "12px",
          padding: "12px 16px",
          borderTop: "1px solid #EAECF0",
        }}
      >
        <Button variant="outlined-md" onClick={handleOpenLearnMorePopUp}>
          {t("pages.payment.overview.cantCreatePaymentLinkPopUP.learnMore")}
        </Button>
        <Button variant="primary-md" onClick={handleSetupPaymentAccount}>
          {t("pages.payment.overview.cantCreatePaymentLinkPopUP.setupPaymentAccount")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default CantCreatePaymentLinkPopUp;
